'use client'
import {
  getAnalyticsUtms,
  getAnalyticsUtmsFromStorage
} from "./chunk-67IEIQJX.mjs";
import {
  checkoutData,
  userData
} from "./chunk-SSYZSLGO.mjs";
import {
  USER_DATA_STORAGE_KEY
} from "./chunk-T2NN7R53.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/trackers/wbk.ts
import { getItem, readCookie, removeItem, safeParseJson, setItem, uuid } from "@wbk/utils";
var WbkTracker = class {
  constructor({ wasDomain, baseDomain, apiToken, log }) {
    this.DUBAI_CART_COOKIE_NAME = "otb_cart_id";
    this.WBK_SESSION_COOKIE_NAME = "utm_wbk_wa_session_id";
    this.setCookieConsent = () => {
    };
    this.setDevice = () => {
    };
    this.pageView = () => {
      const userDataString = getItem(USER_DATA_STORAGE_KEY) || "";
      const userData2 = safeParseJson(userDataString);
      this.sendBeacon({
        eventName: "page_view",
        data: __spreadProps(__spreadValues({}, this.commonPayload), {
          user_id: userData2 == null ? void 0 : userData2._id
        })
      });
    };
    this.signupEvent = (_0) => __async(this, [_0], function* ({ user }) {
      const data = yield userData(user);
      this.sendBeacon({
        eventName: "signup",
        data: __spreadProps(__spreadValues({}, this.commonPayload), {
          user_id: data._id
        })
      });
    });
    this.loginEvent = () => __async(this, null, function* () {
    });
    this.setUser = () => {
    };
    this.viewItemEvent = () => __async(this, null, function* () {
    });
    this.viewItemListEvent = () => {
    };
    this.generateLeadEvent = () => {
    };
    this.viewItemBook = () => {
    };
    this.cartEvent = (props) => __async(this, null, function* () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
      if (!((_b = (_a = props.event) == null ? void 0 : _a.dubai_provider) == null ? void 0 : _b.product_id) || !((_d = (_c = props == null ? void 0 : props.item) == null ? void 0 : _c.dubai_provider) == null ? void 0 : _d.performance_price_type_code)) {
        return;
      }
      const body = {
        product_id: (_e = props.event.dubai_provider) == null ? void 0 : _e.product_id,
        price_code: (_g = (_f = props.item) == null ? void 0 : _f.dubai_provider) == null ? void 0 : _g.performance_price_type_code,
        admits: props.quantity,
        section: (_i = (_h = props.item) == null ? void 0 : _h.dubai_provider) == null ? void 0 : _i.performance_section,
        quantity: props.quantity,
        price: (_k = (_j = props.item) == null ? void 0 : _j.dubai_provider) == null ? void 0 : _k.performance_price,
        ticket_id: (_l = props.item) == null ? void 0 : _l._id
      };
      if (this.cartId === "PENDING") {
        yield new Promise((resolve) => setTimeout(resolve, 2e3));
      }
      if (props.type === "add") {
        if (!this.cartId) {
          this.cartId = "PENDING";
          const res = yield this.sendFetch({
            endpoint: "integration/cart/init",
            data: body
          });
          this.cartId = res.data.data.otb_cart_id;
          setItem(this.DUBAI_CART_COOKIE_NAME, this.cartId);
        } else {
          yield this.sendFetch({
            endpoint: `integration/cart/${this.cartId}`,
            data: body
          });
        }
      } else {
        yield this.sendFetch({
          endpoint: `integration/cart/${this.cartId}/remove-item/${props.item._id}`,
          data: body
        });
      }
    });
    this.viewSummaryEvent = () => {
    };
    this.ticketsSummaryEvent = () => {
    };
    this.paymentSummaryEvent = () => {
    };
    this.beginCheckout = (props) => {
      var _a;
      const data = checkoutData(props);
      this.sendBeacon({
        eventName: "begin_checkout",
        data: __spreadProps(__spreadValues({}, this.commonPayload), {
          slug: ((_a = props.event) == null ? void 0 : _a.slug) || this.commonPayload.slug,
          value: data.order.value,
          currency: data.order.currency,
          coupon: data.order.coupon,
          number_items: data.order.number_items
        })
      });
    };
    this.purchaseEvent = (payment) => __async(this, null, function* () {
      const savedCartId = getItem(this.DUBAI_CART_COOKIE_NAME);
      if (savedCartId) {
        this.sendFetch({
          endpoint: `integration/checkout/${savedCartId}`,
          data: { status: "paid", order_id: payment.order_id }
        });
        removeItem(this.DUBAI_CART_COOKIE_NAME);
      }
    });
    this.purchaseSubscriptionEvent = () => {
    };
    this.purchaseFailed = () => {
    };
    this.registerInterestEvent = () => {
    };
    this.newsletterEvent = () => {
    };
    this.shareEvent = () => {
    };
    this.trackEvent = () => {
    };
    /**
     * Unified function to push data to server using `sendBeacon`
     */
    this.sendBeacon = ({
      eventName,
      data
    }) => {
      if (!(data == null ? void 0 : data.utm_wid)) {
        return;
      }
      const formData = new FormData();
      formData.append("name", eventName);
      for (const key in data) {
        const value = data[key];
        if (value) {
          formData.append(key, value.toString());
        }
      }
      if (typeof navigator !== "undefined") {
        const endpoint = eventName === "page_view" ? "page_view" : "events";
        const url = `${this.wasDomain}/v1/${endpoint}/create`;
        navigator.sendBeacon(url, formData);
        if (this.log) {
          console.log("sendBeacon:", { eventName, data });
        }
      }
    };
    /**
     * Unified function to push data to server using `fetch`
     */
    this.sendFetch = (_0) => __async(this, [_0], function* ({
      endpoint,
      data
    }) {
      const token = readCookie("token") || "";
      const res = yield fetch(`${this.baseDomain}/${endpoint}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          token: this.apiToken,
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });
      const response = yield res.json();
      if (this.log) {
        console.log("sendFetch:", { endpoint, data, response });
      }
      return response;
    });
    this.wasDomain = wasDomain;
    this.baseDomain = baseDomain;
    this.apiToken = apiToken;
    this.log = !!log;
  }
  get commonPayload() {
    const urlUtms = getAnalyticsUtms();
    const utms = urlUtms || getAnalyticsUtmsFromStorage() || {};
    const location = window.location;
    const parts = location.pathname.split("/");
    const url = location.pathname;
    const lang = parts == null ? void 0 : parts[1];
    const slug = parts == null ? void 0 : parts[3];
    return __spreadProps(__spreadValues({}, utms), {
      utm_wbk_wa_session_id: this.wbkSessionId,
      url,
      lang,
      slug
    });
  }
  /**
   * Get the user session id from local storage
   * if it doesn't exist, create a new one
   *
   * even if the user is logged in
   * we will maintain sending both session id and user id
   */
  get wbkSessionId() {
    const savedId = getItem(this.WBK_SESSION_COOKIE_NAME);
    if (!savedId) {
      const newId = typeof crypto !== "undefined" && typeof crypto.randomUUID === "function" ? crypto.randomUUID() : uuid();
      setItem(this.WBK_SESSION_COOKIE_NAME, newId);
      return newId;
    }
    return savedId;
  }
};

export {
  WbkTracker
};
//# sourceMappingURL=chunk-TDDYRI4K.mjs.map